import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

import {getCurrentStatus} from './constant'

export enum CheckStatus {
  commit = 1, // 待提交状态
  check = 2, // 待审核状态
  fail = 3, // 审核失败状态 可以重新填写
  back = 4, // 打回，补充填写 沟通中
  resubmit = 5, // 重新提交
}

export enum InviteStatus {
  fail = -1000,
  invalid = -3, // -3已失效
  rejected = -2, // -2已拒绝
  toBeConfirm = -1, // -1待确认
  confirm = 1, // 1 已确认
}

// overtime = -1000, // -1000超时·未继续，开通失败
// invalid = -3, // -3已失效
// rejected = -2, // -2已拒绝
// toBeConfirm = -1, // -1待确认
// confirm = 1, // 1已确认
// basicUnfilled = 2, // 2基本信息·未填写
// basicUnChecked = 3, // 3基本信息·待审核
// basicFail = 4, // 4基本信息·不符合，开通失败
// detailUnfilled = 5, // 5详细信息·未填写
// detailUnchecked = 6, // 6详细信息·待审核
// detailBack = 7, // 7详细信息·已驳回 重新填写
// detailChat = 8, // 8详细信息·沟通中
// detailFail = 9, // 9详细信息·不符合，开通失败
// inviting = 10, // 10邀请主播·邀请中
// success = 1000, // 1000开通成功
// 待确认（黄色）已确认（绿色）已拒绝（红色）已失效（灰色）

// 获取国家区号棋子
export const getFlagList = createAsyncThunk(
  'GuildSettled/getFlagList',
  async (arg: any, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        hot_list: Array<{
          area_code: number
          country: string
          url?: string
          region_code: number
        }>
        list: Array<{
          area_code: number
          country: string
          url?: string
          region_code: number
        }>
      }>
    >('/live/account/get_flag_list', {
      ...store.getState().env.deviceinfo,
      from: 'bd',
    })
    return resp.data.data
  }
)

// app获取最新填写的信息
export const getSubmitDetail = createAsyncThunk(
  'GuildSettled/getSubmitDetail',
  async (arg: any, store: any) => {
    const resp = await http.post('/live/union/get_submit_detail', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)

// 获取邀请信息
export const getCommonInvite = createAsyncThunk(
  'GuildSettled/getCommonInvite',
  async (arg: any, store: any) => {
    const resp = await http.post('/live/union/get_common_invite_by_ids', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)

// 邀请确认接口
export const commonConfirmInvite = createAsyncThunk(
  'GuildSettled/getCommonInvite',
  async (arg: any, store: any) => {
    const resp = await http.post(
      '/live/union/common_confirm_invite',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 第一次确认接口
export const firstConfirm = createAsyncThunk(
  'GuildSettled/firstConfirm',
  async (arg: any, store: any) => {
    const resp = await http.post('/live/union/bu_read', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)

// 邀请接口 -- 公会长邀请主播
export const unionInviteAnchor = createAsyncThunk(
  'GuildSettled/unionInviteAnchor',
  async (arg: any, store: any) => {
    const resp = await http.post('/live/union/common_invite', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)

// 获取邀请主播历史记录
export const inviteAnchorRecord = createAsyncThunk(
  'GuildSettled/inviteAnchorRecord',
  async (arg: any, store: any) => {
    const resp = await http.post('/live/union/get_common_invite_list', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)

// 基本信息提交 http://wiki.xunlei.cn/pages/viewpage.action?pageId=100429516
export const submitFirstInfo = createAsyncThunk(
  'GuildSettled/submitFirstInfo',
  async (arg: any, store: any) => {
    const resp = await http.post('/live/union/bu_submit_first', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)
export enum CheckName {
  成功 = 1,
  重复,
}
// 校验公会的名字是否合法 http://wiki.xunlei.cn/pages/viewpage.action?pageId=117040435
export const check_union_name = createAsyncThunk(
  'GuildSettled/check_union_name',
  async (arg: {name: string}, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        status: CheckName
      }>
    >('/live/union/check_union_name', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)
// 聊天 http://wiki.xunlei.cn/pages/viewpage.action?pageId=100429537
export const replayByParam = createAsyncThunk(
  'GuildSettled/replayByParam',
  async (arg: any, store: any) => {
    const resp = await http.post('/live/union/reply_bu', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)

// 详细信息提交 http://wiki.xunlei.cn/pages/viewpage.action?pageId=100429518
export const submitSecondInfo = createAsyncThunk(
  'GuildSettled/submitFirstInfo',
  async (arg: any, store: any) => {
    const resp = await http.post('/live/union/bu_submit_second', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)

// 缴纳押金 http://wiki.xunlei.cn/pages/viewpage.action?pageId=100431952
export const payDeposit = createAsyncThunk(
  'GuildSettled/payDeposit',
  async (arg: any, store: any) => {
    const resp = await http.post(
      '/live/union/pay_deposit',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// bd相关配置 http://wiki.xunlei.cn/pages/viewpage.action?pageId=105302002
export const bdCfg = createAsyncThunk(
  'GuildSettled/bd_cfg',
  async (arg: any, store: any) => {
    const resp = await http.post('/live/union/bd_cfg', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

const initialState: {
  detail: any
  chat_list: any
  is_first: boolean
  invite_info?: any // 邀请信息
  invite_record?: any // 邀请主播记录
  deposit?: number
  is_need_deposit?: boolean
  bd_cfg?: {
    fill_app_list?: Array<string>
    min_anchor_cnt?: number
    status_expire_list?: Array<{
      status: number
      expire_sec: number
    }>
    min_income?: number
  }
} = {
  detail: {},
  chat_list: [],
  is_first: true,
  invite_info: {},
  invite_record: {},
  deposit: 0, // 押金数量
  is_need_deposit: false, // 是否需要缴纳
  bd_cfg: {
    fill_app_list: [],
    min_anchor_cnt: 0,
    status_expire_list: [],
    min_income: 0,
  },
}

export const GuildSettledSystemSlice = createSlice({
  name: 'GuildSettledSystem',
  initialState,
  reducers: {
    changeCurStatus: (state, action) => {
      Object.assign(state.detail, {
        curStatus: action.payload.curStatus,
        currentStep: action.payload.currentStep,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSubmitDetail.fulfilled, (state, action) => {
      const data = action.payload
      const status = getCurrentStatus(data?.detail?.status)
      Object.assign(state, {...data})
      if (state?.detail) {
        Object.assign(state?.detail, {...status})
      }
    })
    builder.addCase(getCommonInvite.fulfilled, (state, action) => {
      Object.assign(state.invite_info, action.payload)
    })
    builder.addCase(inviteAnchorRecord.fulfilled, (state, action) => {
      Object.assign(state.invite_record, action.payload)
    })
    builder.addCase(bdCfg.fulfilled, (state, action) => {
      Object.assign(state.bd_cfg, action.payload)
    })
  },
})

export default GuildSettledSystemSlice.reducer
export const GuildSettledActions = GuildSettledSystemSlice.actions
